import {
  param
} from '@/utils'
import request from '@/utils/request'
import requestFile from '@/utils/requestFile'
import {
  method
} from 'lodash'
import {
  Config
} from './config'

// const BASE_URL = 'api';
// eslint-disable-next-line
const BASE_URL = Config.restUrl

export function getMenusTree() {
  return request({
    url: `${BASE_URL}business_catering/hb_menus/tree`,
    method: 'get'
  })
}

export function getMenuList(page, num, sort, asc, keywords) {
  return request({
    url: `${BASE_URL}business_catering/menu/${page}/${num}?sort=${sort}&asc=${asc}&keywords=${keywords}`,
    method: 'get'
  })
}

export function addMenu(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_menus`,
    method: 'post',
    data: params
  })
}

export function updateMenu(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_menus`,
    method: 'put',
    data: params
  })
}

export function deleteMenu(id) {
  return request({
    url: `${BASE_URL}business_catering/hb_menus/${id}`,
    method: 'delete'
  })
}

export function getAuthList(hotelId) {
  return request({
    url: `${BASE_URL}business_catering/hb_authors/${hotelId}`,
    method: 'get'
  })
}

export function addAuth(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_authors`,
    method: 'post',
    data: params
  })
}

export function updateAuth(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_authors`,
    method: 'put',
    data: params
  })
}

export function deleteAuth(id) {
  return request({
    url: `${BASE_URL}business_catering/hb_authors/${id}`,
    method: 'delete'
  })
}

export function getAuthItem(id) {
  return request({
    url: `${BASE_URL}business_catering/hb_authors/author_item/${id}`,
    method: 'get'
  })
}

export function saveAuthItem(params) {
  return request({
    url: `${BASE_URL}business_catering/hb_authors/author_item`,
    method: 'post',
    data: params
  })
}

export function getMerchantList(page, num, sort, asc, SupportDistribution = true, Keywords = '', keywordsType) {
  return request({
    // url: `${BASE_URL}business_resource/catering_merchant/${page}/${num}?sort=${sort}&asc=${asc}&SupportDistribution=${SupportDistribution}&Keywords=${Keywords}&keywordstype=${keywordsType}`,
    url: `${BASE_URL}business_catering/catering_merchant/${page}/${num}?sort=${sort}&asc=${asc}&SupportDistribution=${SupportDistribution}&Keywords=${Keywords}&keywordstype=${keywordsType}`,
    method: 'get'
  })
}

export function addMerchant(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_merchant`,
    method: 'post',
    data: params
  })
}

export function editMerchant(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_merchant/${id}`,
    method: 'put',
    data: params
  })
}

export function delMerchant(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_merchant/${id}`,
    method: 'delete'
  })
}

export function getMerchantById(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_merchant/${id}`,
    method: 'get',
    data: params
  })
}

export function genMerchantQrCode(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_merchant/create_qrcode/${id}`,
    method: 'post'
  })
}

export function getGoodsCatgoryList(page, num, sort, asc, MerchantID, Keywords = '', IsUsed = true, type = '') {
  return request({
    url: `${BASE_URL}business_catering/catering_category/${page}/${num}?sort=${sort}&asc=${asc}&Keywords=${Keywords}&MerchantID=${MerchantID}&IsUsed=${IsUsed}&Type=${type}`,
    method: 'get'
  })
}

export function addGoodsCatgory(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_category`,
    method: 'post',
    data: params
  })
}

export function editGoodsCatgory(params, id) {
  return request({
    url: `${BASE_URL}business_catering/catering_category/${id}`,
    method: 'put',
    data: params
  })
}

export function deleteGoodsCatgory(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_category/${id}`,
    method: 'delete'
  })
}

export function getCateringProductList(page, num, sort, asc, MerchantID, Discount, OnSale, Category, CategoryUsed, Keywords = '') {
  return request({
    url: `${BASE_URL}business_catering/catering_product/${page}/${num}?sort=${sort}&asc=${asc}&MerchantID=${MerchantID}&Discount=${Discount}&OnSale=${OnSale}&Category=${Category}&CategoryUsed=${CategoryUsed}&Keywords=${Keywords}`,
    method: 'get'
  })
}

export function addCateringProduct(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_product`,
    method: 'post',
    data: params
  })
}

export function addCateringProductFlavor(flavorID, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_product_flavor/${flavorID}`,
    method: 'post',
    data: params
  })
}

export function editCateringProduct(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_product/${id}`,
    method: 'put',
    data: params
  })
}

export function getCateringProductById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_product/${id}`,
    method: 'get'
  })
}

export function changeSaleStatus(id, onSale, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_product/change_sale_status/${id}?onsale=${onSale}`,
    method: 'put',
    data: params
  })
}

export function deleteCateringProduct(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_product/${id}`,
    method: 'delete'
  })
}

export function getCateringFlavorListInChoose(page, num, sort, asc, MerchantID, IsRequired, IsDiscount, IsMultiple, Keywords = '') {
  return request({
    url: `${BASE_URL}business_catering/catering_flavor/${page}/${num}?sort=${sort}&asc=${asc}&Keywords=${Keywords}&IsRequired=${IsRequired}&IsDiscount=${IsDiscount}&IsMultiple=${IsMultiple}&MerchantID=${MerchantID}`,
    method: 'get'
  })
}

/*
// 查询单个商品口味组关联
export function getCateringProductFlavorByProductId(id) {
  return request({
    url: `${BASE_URL}business_resource/catering_product_flavor/${id}`,
    method: 'get'
  })
}*/

// 获取单位
export function getUnit() {
  return request({
    url: `${BASE_URL}business_catering/attributes/CateringProductUnit`,
    method: 'get'
  })
}

export function getCateringProductByFlavor(flavorID) {
  return request({
    url: `${BASE_URL}business_catering/catering_product/get_by_flavor/${flavorID}`,
    method: 'get'
  })
}

export function UploadImageApi(formData) {
  return requestFile({
    url: `${BASE_URL}core_common/pictures/upload_file`,
    method: 'post',
    data: formData
  })
}

export function setImageValid(data) {
  return request({
    url: `${BASE_URL}core_common/pictures/update_pictures_description`,
    method: 'post',
    data: data
  })
}

/*
export function getPartnerById(id) {
  return request({
    url: `${BASE_URL}business_material/partner/${id}`,
    method: 'get'
  })
}

export function editPartner(id, params) {
  return request({
    url: `${BASE_URL}business_material/partner/${id}`,
    method: 'put',
    data: params
  })
}

export function deletePartner(id) {
  return request({
    url: `${BASE_URL}business_material/partner/${id}`,
    method: 'delete'
  })
}*/

export function getCateringFlavorList(page, num, sort, asc, merchantID, keywords, isRequired, isDiscount, isMultiple) {
  return request({
    url: `${BASE_URL}business_catering/catering_flavor/${page}/${num}?sort=${sort}&asc=${asc}&merchantID=${merchantID}&keywords=${keywords}&isRequired=${isRequired}&isDiscount=${isDiscount}&isMultiple=${isMultiple}`,
    method: 'get'
  })
}

export function getCateringFlavorById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_flavor/${id}`,
    method: 'get'
  })
}

export function addCateringFlavor(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_flavor/`,
    method: 'post',
    data: params
  })
}

export function updateCateringFlavor(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_flavor/${id}`,
    method: 'put',
    data: params
  })
}

export function deleteCateringFlavor(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_flavor/${id}`,
    method: 'delete'
  })
}

// export function getCateringDistributionPointList(page, num, sort, asc) {
//   return request({
//     url: `${BASE_URL}business_resource/catering_distribution_point/${page}/${num}?sort=${sort}&asc=${asc}`,
//     method: 'get'
//   })
// }

export function getCateringDistributionPointList(merchantID) {
  return request({
    url: `${BASE_URL}business_catering/catering_distribution_point/get_by_merchant/${merchantID}`,
    method: 'get'
  })
}

export function getCateringDistributionPointById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_distribution_point/${id}`,
    method: 'get'
  })
}

export function addCateringDistributionPoint(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_distribution_point/`,
    method: 'post',
    data: params
  })
}

export function updateCateringDistributionPoint(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_distribution_point/${id}`,
    method: 'put',
    data: params
  })
}

export function deleteCateringDistributionPoint(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_distribution_point/${id}`,
    method: 'delete'
  })
}

export function getCateringPromotionPointList(merchantID) {
  return request({
    url: `${BASE_URL}business_catering/catering_promotion_point/get_by_merchant/${merchantID}`,
    method: 'get'
  })
}

export function getCateringPromotionPointById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_promotion_point/${id}`,
    method: 'get'
  })
}

export function addCateringPromotionPoint(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_promotion_point/`,
    method: 'post',
    data: params
  })
}

export function updateCateringPromotionPoint(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_promotion_point/${id}`,
    method: 'put',
    data: params
  })
}

export function delCateringPromotionPoint(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_promotion_point/${id}`,
    method: 'delete'
  })
}

export function genCateringPromotionPointCode(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_promotion_point/create_qrcode/${id}`,
    method: 'post'
  })
}

export function getCateringOrder(page, num, sort, asc, merchantID, dateType, beginDate, endDate, addressPoint, promotionPoint, keywordsType, keywords, status, issuingStatus) {
  return request({
    url: `${BASE_URL}business_catering/catering_order/${page}/${num}?sort=${sort}&asc=${asc}&merchantID=${merchantID}&dateType=${dateType}&beginDate=${beginDate}&endDate=${endDate}&addressPoint=${addressPoint}&promotionPoint=${promotionPoint}&keywordsType=${keywordsType}&keywords=${keywords}&status=${status}&issuingStatus=${issuingStatus}`,
    method: 'get'
  })
}

export function getCateringOrderById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_order/${id}`,
    method: 'get'
  })
}

export function cateringOrderCompleted(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_order/completed_confirm/${id}`,
    method: 'post'
  })
}

export function cateringOrderDiningOut(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_order/dinning_out_confirm/${id}`,
    method: 'post'
  })
}

export function getCateringOrderRefund(page, num, sort, asc, merchantID, keywords, dateType, beginTime, endTime, status) {
  return request({
    url: `${BASE_URL}business_catering/catering_order_refund/${page}/${num}?sort=${sort}&asc=${asc}&merchantID=${merchantID}&keywords=${keywords}&dateType=${dateType}&beginTime=${beginTime}&endTime=${endTime}&status=${status}`,
    method: 'get'
  })
}

export function getCateringOrderRefundById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_order_refund/${id}`,
    method: 'get'
  })
}

// 退款
export function cateringOrderRefund(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_order_refund/refund_confirmed`,
    method: 'post',
    data: params
  })
}

// 获取退款状态
export function getRefundStatus() {
  return request({
    url: `${BASE_URL}business_catering/attributes/refundStatus`,
    method: 'get'
  })
}

// 获取attribute枚举
export function getAttributes(attributes) {
  return request({
    url: `${BASE_URL}business_catering/attributes/${attributes}`,
    method: 'get'
  })
}

// 插入广告
export function addAd(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_ad`,
    method: 'post',
    data: params
  })
}

// 获取广告列表
// export function getAdList(merchantID) {
//   return request({
//     url: `${BASE_URL}business_catering/catering_ad/get_all/${merchantID}`,
//     method: 'get'
//   })
// }

export function getAdList(type, merchantID) {
  return request({
    url: `${BASE_URL}business_catering/catering_ad/get_all?type=${type}&merchantID=${merchantID}`,
    method: 'get'
  })
}

// 获取单个广告
export function getAdById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_ad/${id}`,
    method: 'get'
  })
}

// 插入广告
export function editAd(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_ad/${id}`,
    method: 'put',
    data: params
  })
}

// 删除广告
export function delAdd(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_ad/${id}`,
    method: 'delete'
  })
}

// 获取营业概况
export function getBasicReport(merchantID, dateType, beginDate, endDate) {
  return request({
    url: `${BASE_URL}business_catering/catering_report/get_basic_report/${merchantID}?dateType=${dateType}&beginDate=${beginDate}&endDate=${endDate}`,
    method: 'get'
  })
}

// 获取营业预警
export function getBusinessWarn(merchantId) {
  return request({
    url: `${BASE_URL}business_catering/catering_report/get_business_warn/${merchantId}`,
    method: 'get'
  })
}

// 营收日报
export function getDailyReport(merchantId) {
  return request({
    url: `${BASE_URL}business_catering/catering_report/get_daily_report/${merchantId}`,
    method: 'get'
  })
}

// 打印标签
export function printTag(orderId, type) {
  return request({
    url: `${BASE_URL}business_catering/catering_order/manua_print/${orderId}?type=${type}`,
    method: 'post'
  })
}

// 会员分页
export function getMembersByPage(page, num, sort, asc, keywordsType, keywords) {
  return request({
    url: `${BASE_URL}business_catering/catering_member/${page}/${num}?sort=${sort}&asc=${asc}&keywordsType=${keywordsType}&keywords=${keywords}`,
    method: 'get'
  })
}

// 获取单个会员信息
export function getMemberById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_member/${id}`,
    method: 'get'
  })
}

// 修改单个会员信息
export function editMemberInfo(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_member/${id}`,
    method: 'put',
    data: params
  })
}

// 会员充值数
export function memberRecharge(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_member/recharge`,
    method: 'post',
    data: params
  })
}

// 获取会员充值记录
export function getRechargeRecord(memberID) {
  return request({
    url: `${BASE_URL}business_catering/catering_member/get_recharge_record/${memberID}`,
    method: 'get'
  })
}

// 分页获取会员充值记录
export function getRechargeRecordPage(page, size, merchantID, memberID, beginDate, endDate, keywords, type, keywordsType) {
  return request({
    url: `${BASE_URL}business_catering/catering_recharge_record/${page}/${size}?beginDate=${beginDate}&endDate=${endDate}&keywords=${keywords}&type=${type}&keywordsType=${keywordsType}`,
    method: 'get'
  })
}

export function getMemberRechargeRecord(page, num, sort, asc, beginDate, endDate, keywords, keywordsType) {
  return request({
    url: `${BASE_URL}business_catering/catering_recharge_record/${page}/${num}?sort=${sort}&asc=${asc}&beginDate=${beginDate}&endDate=${endDate}&keywords=${keywords}&keywordsType=${keywordsType}`,
    method: 'get'
  })
}

// 分页获取储值卡
export function getDepositPage(page, num, sort, asc, isUsed) {
  return request({
    url: `${BASE_URL}business_catering/catering_rechargeable_cards/${page}/${num}?sort=${sort}&asc=${asc}&isUsed=${isUsed}`,
    method: 'get'
  })
}

// 获取单个储值卡信息
export function getDepositById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_rechargeable_cards/${id}`,
    method: 'get'
  })
}

// 添加单个储值卡信息
export function addDeposit(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_rechargeable_cards/`,
    method: 'post',
    data: params
  })
}

// 修改单个储值卡信息
export function updateDeposit(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_rechargeable_cards/${id}`,
    method: 'put',
    data: params
  })
}

// 删除单个储值卡信息
export function delDeposit(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_rechargeable_cards/${id}`,
    method: 'delete'
  })
}

// 查询餐饮配置
export function getCateringSetting() {
  return request({
    url: `${BASE_URL}business_catering/catering_setting`,
    method: 'get'
  })
}

// 提交餐饮配置
export function postCateringSetting() {
  return request({
    url: `${BASE_URL}business_catering/catering_setting`,
    method: 'post'
  })
}

// 商家餐桌列表
export function getDinnerTableList(page, num, sort, asc, code, type, merchantID) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/${page}/${num}?sort=${sort}&asc=${asc}&merchantID=${merchantID}&code=${code}&type=${type}`,
    method: 'get'
  })
}

// 商家餐桌单张
export function getDinnerTableById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/${id}`,
    method: 'get'
  })
}

// 添加餐桌
export function addDinnerTable(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/`,
    method: 'post',
    data: params
  })
}

// 批量添加餐桌
export function BulkAddDinnerTables(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/bulk_add`,
    method: 'post',
    data: params
  })
}

// 修改餐桌
export function updateDinnerTable(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/${id}`,
    method: 'put',
    data: params
  })
}

// 删除餐桌
export function deleteDinnerTable(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/${id}`,
    method: 'delete'
  })
}

// 生成餐桌二维码
export function qrCodeDinnerTable(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_desk/create_qrcode/${id}`,
    method: 'post'
  })
}

// 枚举访问
export function getEnums(names) {
  return request({
    url: `${BASE_URL}business_catering/attributes/${names}`,
    method: 'get'
  })
}

// 分页获取优惠券
export function getCashCouponList(page, num, sort, asc, name, denomination, type, status) {
  return request({
    url: `${BASE_URL}business_catering/catering_cashcoupon/${page}/${num}?sort=${sort}&asc=${asc}&name=${name}&denomination=${denomination}&type=${type}&status=${status}`,
    method: 'get'
  })
}

// 获取单个优惠券
export function getCashCouponById(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_cashcoupon/${id}`,
    method: 'get'
  })
}

// 添加优惠券
export function addCashCoupon(params) {
  return request({
    url: `${BASE_URL}business_catering/catering_cashcoupon/`,
    method: 'post',
    data: params
  })
}

// 修改优惠券
export function updateCashCoupon(id, params) {
  return request({
    url: `${BASE_URL}business_catering/catering_cashcoupon/${id}`,
    method: 'put',
    data: params
  })
}

// 删除优惠券
export function deleteCashCoupon(id) {
  return request({
    url: `${BASE_URL}business_catering/catering_cashcoupon/${id}`,
    method: 'delete'
  })
}
